import { render, staticRenderFns } from "./SalesMetricsDashboard.vue?vue&type=template&id=67292cd9"
import script from "./SalesMetricsDashboard.vue?vue&type=script&lang=js"
export * from "./SalesMetricsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports